<div>
    <h2 class="headline-06 mb-2 md:mt-3 text-[#134F82]">Selecciona una categoría</h2>
    <mat-form-field appearance="fill" class="w-full">
        <mat-select [(ngModel)]="selectedCategory">
            <mat-option *ngFor="let category of categories" [value]="category">
                {{category}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div>
    <h2 class="headline-05 mb-2 text-[#134F82] flex items-center gap-1">
        Selecciona tu dirección
    </h2>

    <!-- Casa -->
    <div class="bg-[#D2E4FF29] border border-[#D9E7F3] rounded-2xl p-2 flex items-center gap-2 mb-2 cursor-pointer"
         [class.border-[#134F82]]="selectedAddress === 'casa'"
         (click)="selectedAddress = 'casa'">
        <div class="w-6 h-6 flex items-center justify-center">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.54952 1.03189C8.38743 0.325305 9.61257 0.325306 10.4505 1.0319L17.2005 6.724C17.7074 7.15152 18 7.7809 18 8.44406L18 17.7539C18 18.7204 17.2165 19.5039 16.25 19.5039H12.75C11.7835 19.5039 11 18.7204 11 17.7539L11 12.7468C11 12.6088 10.8881 12.4968 10.75 12.4968H7.24999C7.11192 12.4968 6.99999 12.6088 6.99999 12.7468L6.99999 17.7539C6.99999 18.7204 6.2165 19.5039 5.25 19.5039H1.75C0.783502 19.5039 0 18.7204 0 17.7539V8.44406C0 7.7809 0.292551 7.15152 0.799517 6.724L7.54952 1.03189ZM9.48349 2.1786C9.20419 1.94307 8.79581 1.94307 8.5165 2.1786L1.76651 7.87071C1.59752 8.01321 1.5 8.22301 1.5 8.44406L1.5 17.7539C1.5 17.892 1.61193 18.0039 1.75 18.0039H5.25C5.38807 18.0039 5.49999 17.892 5.49999 17.7539L5.49999 12.7468C5.49999 11.7803 6.2835 10.9968 7.24999 10.9968H10.75C11.7165 10.9968 12.5 11.7803 12.5 12.7468L12.5 17.7539C12.5 17.892 12.6119 18.0039 12.75 18.0039H16.25C16.3881 18.0039 16.5 17.892 16.5 17.7539L16.5 8.44406C16.5 8.22301 16.4025 8.01321 16.2335 7.87071L9.48349 2.1786Z" fill="#242424"/>
            </svg>
        </div>
        <div class="flex-1">
            <h4 class="text-[#134F82] font-bold text-lg leading-tight">Casa</h4>
            <p class="text-[#134F82] text-sm">Av. Colmena 360, Int 1, 01120, Álvaro Obregón, CDMX</p>
        </div>
        <mat-radio-button
            name="address"
            value="casa"
            [(ngModel)]="selectedAddress">
        </mat-radio-button>
    </div>

    <!-- Oficina -->
    <div class="bg-[#D2E4FF29] border border-[#D9E7F3] rounded-2xl p-2 flex items-center gap-2 mb-2 cursor-pointer"
         [class.border-[#134F82]]="selectedAddress === 'oficina'"
         (click)="selectedAddress = 'oficina'">
        <div class="w-6 h-6 flex items-center justify-center">
            <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.25 2C1.83579 2 1.5 2.33579 1.5 2.75V19H3.5V16.25C3.5 15.5596 4.05964 15 4.75 15H11.25C11.9404 15 12.5 15.5596 12.5 16.25V19H14.5V10.25C14.5 9.83579 14.1642 9.5 13.75 9.5H11.75C11.3358 9.5 11 9.16421 11 8.75V2.75C11 2.33579 10.6642 2 10.25 2H2.25ZM5 16.5V19H7.25V16.5H5ZM8.75 16.5V19H11V16.5H8.75ZM15.25 20.5H0.75C0.335786 20.5 0 20.1642 0 19.75V2.75C0 1.50736 1.00736 0.5 2.25 0.5H10.25C11.4926 0.5 12.5 1.50736 12.5 2.75V8H13.75C14.9926 8 16 9.00736 16 10.25V19.75C16 20.1642 15.6642 20.5 15.25 20.5ZM3.5 5C3.5 4.44772 3.94772 4 4.5 4C5.05229 4 5.5 4.44772 5.5 5C5.5 5.55228 5.05229 6 4.5 6C3.94772 6 3.5 5.55228 3.5 5ZM4.5 11C3.94772 11 3.5 11.4477 3.5 12C3.5 12.5523 3.94772 13 4.5 13C5.05229 13 5.5 12.5523 5.5 12C5.5 11.4477 5.05229 11 4.5 11ZM4.5 7.5C3.94772 7.5 3.5 7.94771 3.5 8.5C3.5 9.05229 3.94772 9.5 4.5 9.5C5.05229 9.5 5.5 9.05229 5.5 8.5C5.5 7.94771 5.05229 7.5 4.5 7.5ZM8 4C7.44771 4 7 4.44772 7 5C7 5.55228 7.44771 6 8 6C8.55229 6 9 5.55228 9 5C9 4.44772 8.55229 4 8 4ZM8 11C7.44771 11 7 11.4477 7 12C7 12.5523 7.44771 13 8 13C8.55229 13 9 12.5523 9 12C9 11.4477 8.55229 11 8 11ZM11.5 11C10.9477 11 10.5 11.4477 10.5 12C10.5 12.5523 10.9477 13 11.5 13C12.0523 13 12.5 12.5523 12.5 12C12.5 11.4477 12.0523 11 11.5 11ZM8 7.5C7.44771 7.5 7 7.94771 7 8.5C7.5 9.05229 7.44771 9.5 8 9.5C8.55229 9.5 9 9.05229 9 8.5C9 7.94771 8.55229 7.5 8 7.5Z" fill="#134F82"/>
            </svg>
        </div>
        <div class="flex-1">
            <h4 class="text-[#134F82] font-bold text-lg leading-tight">Oficina</h4>
            <p class="text-[#134F82] text-sm">Av. Santa Fe 440, Pis 11590, Cuajimalpa, CDMX</p>
        </div>
        <mat-radio-button
            name="address"
            value="oficina"
            [(ngModel)]="selectedAddress">
        </mat-radio-button>
    </div>

    <!-- Botón Agregar dirección -->
    <button class="w-full mt-3 border border-[#0E365A] rounded-full p-3 flex justify-between items-center bg-transparent">
        <span class="text-[#0E365A] text-xs font-bold tracking-wider">Agregar dirección nueva</span>
        <mat-icon class="text-[#0E365A] text-xs">add</mat-icon>
    </button>
</div>

<div class="mt-4">
    <h3 class="text-[#134F82] font-bold text-lg mb-2">¿Esta es una consulta por COVID?</h3>
    <div class="flex items-center gap-2">
        <mat-checkbox
            [(ngModel)]="isCovid"
            class="text-[#0E365A]">
        </mat-checkbox>
        <span class="text-[#0E365A] text-sm">Esta consulta médica es relacionada con COVID.</span>
    </div>
</div>

<!--mat-progress-bar mode="determinate" [value]="progressValue" color="primary" class="my-4"></mat-progress-bar-->

<button class="bg-[#0E365A] text-white w-full py-3 my-3 rounded-full" (click)="goToNextStep()">
    Confirmar dirección
</button>
